// Special module used when condition of dojo/has failed and no failback module specified
module.exports = undefined;


//////////////////
// WEBPACK FOOTER
// ./~/dojo-webpack-loader/lib/no-module.js
// module id = 59
// module chunks = 0